'use strict';

/**
 * WHEN A PURCHASE CHARGES WITHOUT LEAVING THE PAGE, IT HAS TO ASK FIRST.
 *
 * A first purchase shows its price at Stripe Checkout. A same-interval tier
 * upgrade can charge the saved card, so its exact signed quote needs consent
 * before execution. Stripe may still require a payment page for authentication.
 *
 * The store used to charge and THEN say "Your pass is upgraded". On 2026-08-27 the
 * owner pressed the button, was charged $10.14, and reported it as a suspected bug
 * precisely because nothing had asked him. The money was correctly taken - invoice
 * in_1U9DOR..., billing_reason=subscription_update, paid - so it was never a
 * billing defect. It was a consent defect, and worse under EU/UK consumer rules
 * than the redirect it replaces.
 *
 * Extracted here rather than left inside store.js's closure so the rule is
 * testable on its own: the whole point is that it must not silently stop firing.
 */

/* The server's own set. SUBSCRIPTION_PLAN_TYPES in game/utils/subscriptionPlans.js
   is exactly storyteller_/manga_ x monthly/yearly. Matched by shape because this
   module is bundled for the browser, and the check only needs to exclude the
   one-off skus - stardust packs, moonlight_refill - that share the checkout entry
   point. A one-off still redirects to Stripe, so it asks for itself. */
const SUBSCRIPTION_PLAN_SHAPE = /^(storyteller|manga)_(monthly|yearly)$/;

/**
 * True only when pressing buy will charge a card immediately with no payment page.
 *
 * Only Storyteller -> Manga on the same billing interval is an in-place tier
 * upgrade. Interval conversions use the billing portal rather than this charge.
 */
function isImmediateUpgradeCharge(subscriptionState, planType, billingInterval) {
  return subscriptionState === 'storyteller'
    && ((billingInterval === 'month' && planType === 'manga_monthly')
      || (billingInterval === 'year' && planType === 'manga_yearly'));
}

export { SUBSCRIPTION_PLAN_SHAPE, isImmediateUpgradeCharge };
